import CustomSelect from 'components/shared/CustomSelect';
import FormGroup from 'components/shared/FormGroup';
import GENDERSALARYBYROLEANDEXPERIENCE from 'data/mantechcar24/gender-salary-by-role-and-experience.json';
import GENDERSALARYBYROLE from 'data/mantechcar24/gender-salary-by-role.json';

import { useI18n } from 'hooks/useI18n';
import { useEffect, useMemo, useState } from 'react';
import {
  GenderSalaryByRoleAndExperienceDataProps,
  GenderSalaryByRoleAndExperienceDataTier,
  GenderSalaryByRoleAndExperienceDropdownItem
} from './Gender.types';
import {
  StyledInputs,
  StyledLabel,
  StyledOutput,
  StyledOutputs,
  StyledSection,
  StyledValue
} from './GenderCalculator.styled';

const GenderCalculator: React.FC = () => {
  const [currentRole, setCurrentRole] = useState<string>();
  const [currentYears, setCurrentYears] = useState<string>();
  const [currentWomenSalary, setCurrentWomenSalary] = useState<string>('--');
  const [currentMenSalary, setCurrentMenSalary] = useState<string>('--');
  const { t } = useI18n('developer-career-report-2024');

  const ROLES: GenderSalaryByRoleAndExperienceDropdownItem[] = useMemo(
    () =>
      GENDERSALARYBYROLEANDEXPERIENCE.map(({ role }) => ({
        label: role,
        value: role
      })),
    []
  );

  const YEARS: GenderSalaryByRoleAndExperienceDropdownItem[] = useMemo(
    () => [
      {
        label: '<2',
        value: 'tier1'
      },
      {
        label: '2-5',
        value: 'tier2'
      },
      {
        label: '5-10',
        value: 'tier3'
      },
      {
        label: '>10',
        value: 'tier4'
      }
    ],
    []
  );

  const handleRoleChange = ({
    value
  }: GenderSalaryByRoleAndExperienceDropdownItem): void => {
    setCurrentRole(value);
  };

  const handleYearsChange = ({
    value
  }: GenderSalaryByRoleAndExperienceDropdownItem): void => {
    setCurrentYears(value);
  };

  useEffect(() => {
    if (currentRole !== undefined && currentYears !== undefined) {
      const data = GENDERSALARYBYROLEANDEXPERIENCE.find(
        (data) => data.role === currentRole
      ) as GenderSalaryByRoleAndExperienceDataProps;

      const { female, male } = data[
        currentYears as keyof GenderSalaryByRoleAndExperienceDataProps
      ] as GenderSalaryByRoleAndExperienceDataTier;

      setCurrentMenSalary(male.toFixed(1));
      setCurrentWomenSalary(female.toFixed(1));
    } else {
      setCurrentMenSalary('--');
      setCurrentWomenSalary('--');
    }
  }, [currentRole, currentYears]);

  return (
    <StyledSection>
      <StyledInputs>
        <FormGroup
          label={t('mantechcar24.gender.calculator-experience.calculator.role')}
          forId="genderRole"
        >
          <CustomSelect
            defaultValue={GENDERSALARYBYROLE[0].role}
            id="genderRole"
            isSmall
            onChange={handleRoleChange}
            options={ROLES}
            matchOrder={false}
          />
        </FormGroup>
        <FormGroup
          label={t(
            'mantechcar24.gender.calculator-experience.calculator.years'
          )}
          forId="genderRole"
        >
          <CustomSelect
            defaultValue={YEARS[0].value}
            id="genderExperience"
            isSmall
            onChange={handleYearsChange}
            options={YEARS}
            matchOrder={false}
          />
        </FormGroup>
      </StyledInputs>
      <StyledOutputs>
        <StyledOutput>
          <StyledLabel>
            {t('mantechcar24.gender.calculator-experience.calculator.women')}
          </StyledLabel>
          <StyledValue>
            €<span>{currentWomenSalary}</span>K
          </StyledValue>
        </StyledOutput>
        <StyledOutput>
          <StyledLabel>
            {t('mantechcar24.gender.calculator-experience.calculator.men')}
          </StyledLabel>
          <StyledValue>
            €<span>{currentMenSalary}</span>K
          </StyledValue>
        </StyledOutput>
      </StyledOutputs>
    </StyledSection>
  );
};

export default GenderCalculator;
